// The user's selected zoom setting for the annotator views. Persisted to
// localStorage so it survives page reloads and recording switches; the slice
// seeds `settings.scale` from here and writes back on every `setScale`.
// Clamped to the same [0.25, 3] range the Toolbar exposes.
const STORAGE_KEY = "annotatorScale"
const MIN_SCALE = 0.25
const MAX_SCALE = 3
const DEFAULT_SCALE = 1

const clamp = (n) => Math.min(MAX_SCALE, Math.max(MIN_SCALE, n))

export const getPersistedScale = () => {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY)
        if (raw == null) return DEFAULT_SCALE
        const parsed = Number(raw)
        if (!Number.isFinite(parsed)) return DEFAULT_SCALE
        return clamp(parsed)
    } catch {
        return DEFAULT_SCALE
    }
}

export const setPersistedScale = (scale) => {
    try {
        const n = Number(scale)
        if (!Number.isFinite(n)) return
        window.localStorage.setItem(STORAGE_KEY, String(clamp(n)))
    } catch {
        // localStorage can throw (private browsing, quota) — safe to ignore;
        // the in-memory Redux value is still authoritative for this session.
    }
}
